<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="道路选择">
              <a-input v-model="query.road" placeholder="请输入道路选择" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编号">
              <a-input v-model="query.classNo" placeholder="请输入分类编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入物探点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="构筑物">
              <a-select placeholder="请选择构筑物" v-model="query.structure" allow-clear>
                <a-select-option v-for="item in structureOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="材质">
              <a-select v-model="query.textureMaterial" placeholder="请选择管线材质" allow-clear>
                <a-select-option v-for="(item, index) in pipeLineMaterialOptions" :key="index" :value="item">{{
                  item
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="口径">
              <a-select placeholder="请选择口径大小" v-model="query.caliber" allow-clear>
                <a-select-option v-for="(item, index) in pipeDiameterSizeOptions" :key="index" :value="item">
                  DN{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="特征点">
              <a-select placeholder="请选择特征点" v-model="query.featurePoint" allow-clear>
                <a-select-option v-for="item in featurePointOptions" :key="item" :value="item">{{
                  item
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="附属物">
              <a-select placeholder="请选择附属物" v-model="query.appendage" allow-clear>
                <a-select-option v-for="item in appendageOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ excelForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                v-action:recycle>回收站</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="clear" v-action:clear>一键清空数据</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-row class="form-row" :gutter="16">
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编号">
              <a-input :disabled="this.isUpdate" placeholder="分类编号" style="width: 100%"
                v-decorator="['class_no', { rules: [{ required: true, message: '请输入分类编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物探点号">
              <a-input placeholder="物探点"
                v-decorator="['geophysicalPointNumber', { rules: [{ required: true, message: '请输入物探点号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="特征点">
              <a-input placeholder="特征点"
                v-decorator="['featurePoint', { rules: [{ required: false, message: '请输入特征点' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附属物">
              <a-input placeholder="附属物"
                v-decorator="['appendage', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="构筑物">
              <a-input placeholder="构筑物"
                v-decorator="['structure', { rules: [{ required: false, message: '请输入构筑物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点X">
              <a-input placeholder="坐标点X" v-decorator="[
                'point_x',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点X' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点Y">
              <a-input placeholder="坐标点Y" v-decorator="[
                'point_y',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点Y' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程">
              <a-input placeholder="地面高程" v-decorator="[
                'elevation',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入地面高程m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径">
              <a-input placeholder="口径" v-decorator="['caliber', { rules: [{ required: false, message: '请输入口径' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="材质">
              <a-input placeholder="材质"
                v-decorator="['textureMaterial', { rules: [{ required: false, message: '请输入材质' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="埋深m">
              <a-input placeholder="埋深" v-decorator="[
                'buriedDepth',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入埋深m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="敷设方式">
              <a-input placeholder="敷设方式"
                v-decorator="['layingMode', { rules: [{ required: false, message: '请输入敷设方式' }] }]" />
            </a-form-item>
          </a-col>
          <!--          <a-col :lg="12" :md="12" :sm="24">-->
          <!--            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">-->
          <!--              <a-tree-select-->
          <!--                :tree-data="zoneTreeData"-->
          <!--                v-decorator="['zoneId', { rules: [{ required: false, message: '请选择片区' }] }]"-->
          <!--                style="width: 100%"-->
          <!--                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"-->
          <!--                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"-->
          <!--                placeholder="请选择片区"-->
          <!--                allow-clear-->
          <!--                tree-default-expand-all-->
          <!--              ></a-tree-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称">
              <a-input placeholder="片区名称"
                v-decorator="['zoneName', { rules: [{ required: false, message: '请输入片区名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="道路选择">
              <a-input placeholder="所属道路"
                v-decorator="['road', { rules: [{ required: false, message: '请输入所属道路' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原始文件名">
              <a-input placeholder="原始文件名"
                v-decorator="['originalFileName', { rules: [{ required: false, message: '请输入原始文件名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="探测台组编号">
              <a-input placeholder="探测台组编号"
                v-decorator="['probeGroupNo', { rules: [{ required: false, message: '请输入探测台组编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表数量">
              <a-input placeholder="水表数量" v-decorator="[
                'water_count',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入水表数量' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门类型">
              <a-input placeholder="阀门类型"
                v-decorator="['valve_type', { rules: [{ required: false, message: '请输入阀门类型' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
              <a-select placeholder="请选择状态" v-decorator="['status', { initialValue: '良好' }]">
                <a-select-option value="良好">良好</a-select-option>
                <a-select-option value="密封性能差">密封性能差</a-select-option>
                <a-select-option value="损坏">损坏</a-select-option>
                <a-select-option value="联通阀门关闭">联通阀门关闭</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌">
              <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: false, message: '请输入品牌' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出厂编号">
              <a-input placeholder="出厂编号"
                v-decorator="['factoryNumber', { rules: [{ required: false, message: '请输入出厂编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号">
              <a-input placeholder="型号" v-decorator="['model', { rules: [{ required: false, message: '请输入型号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程名称">
              <a-input placeholder="工程名称"
                v-decorator="['projectName', { rules: [{ required: false, message: '请输入工程名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程类别">
              <a-input placeholder="工程类别"
                v-decorator="['projectType', { rules: [{ required: false, message: '工程类别' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程编号">
              <a-input placeholder="工程编号"
                v-decorator="['projectNo', { rules: [{ required: false, message: '工程编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="施工单位">
              <a-input placeholder="施工单位"
                v-decorator="['constructionUnit', { rules: [{ required: false, message: '施工单位' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程管理人">
              <a-input placeholder="工程管理人"
                v-decorator="['projectManager', { rules: [{ required: false, message: '工程管理人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程负责人">
              <a-input placeholder="工程负责人"
                v-decorator="['projectLeader', { rules: [{ required: false, message: '工程负责人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="竣工时间">
              <a-input placeholder="竣工时间"
                v-decorator="['completion_date', { rules: [{ required: false, message: '竣工时间' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '备注' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加压泵类型">
              <a-input placeholder="加压泵类型"
                v-decorator="['forcingPumpStatus', { rules: [{ required: false, message: '请输入加压泵类型' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机组数量">
              <a-input placeholder="机组数量" v-decorator="[
                'unitNum',
                { rules: [{ pattern: /^[0-9]*[1-9][0-9]*$/, required: false, message: '请输入机组数量' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机组功率">
              <a-input placeholder="机组功率" v-decorator="[
                'unitPower',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入机组功率' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门级别">
              <a-input-number placeholder="阀门级别" :min="1" v-decorator="[
                'valveLevel',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入阀门级别' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门编号">
              <a-input placeholder="阀门编号"
                v-decorator="['valveNo', { rules: [{ required: false, message: '请输入阀门编号' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <importModal ref="importModal" :tree-data="road" exportUrl="/pipe-network/gis/pipe-networks/import" @close="close"
      @reLoad="resetList"></importModal>
    <RecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk"></RecycleBinModal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import importModal from './module/ImportModalNotZone.vue'
import RecycleBinModal from './module/NewPipeNetworkRecycleBinModal'
import { listPipeNetworkByGroupProperties, getPipeDiameterSizeOptions, getPipeLineMaterialOptions } from '@/api/manage'
import moment from 'moment'
import { handleImportBlobResponse } from '@/utils/importUtils'

const STATUS = {
  1: '正常',
  2: '禁用',
}

const columns = [
  {
    title: '分类编号',
    dataIndex: 'class_no',
  },
  {
    title: '阀门编号',
    dataIndex: 'valveNo',
  },
  {
    title: '物探点',
    dataIndex: 'geophysicalPointNumber',
  },
  {
    title: '特征点',
    dataIndex: 'featurePoint',
  },
  {
    title: '附属物',
    dataIndex: 'appendage',
  },
  {
    title: '构筑物',
    dataIndex: 'structure',
  },
  {
    title: '坐标X',
    dataIndex: 'point_x',
  },
  {
    title: '坐标Y',
    dataIndex: 'point_y',
  },
  {
    title: '材质',
    dataIndex: 'textureMaterial',
  },
  {
    title: '口径',
    dataIndex: 'caliber',
  },
  {
    title: '埋深',
    dataIndex: 'buriedDepth',
  },
  {
    title: '地面高程',
    dataIndex: 'elevation',
  },
  {
    title: '所在道路',
    dataIndex: 'road',
  },
  {
    title: '阀门级别',
    dataIndex: 'valveLevel',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },

  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'GisPipeNetworkList',
  components: {
    importModal,
    RecycleBinModal,
  },
  data () {
    return {
      PointList: [],
      LineList: [],
      recycleBinVisible: false,
      zoneId: '',
      openSelectFile: false,
      importLoading: false,
      fileList: [],
      queryUrl: 'pipe-network/gis/pipe-networks/page',
      addOrUpdateUrl: 'pipe-network/gis/pipe-networks',
      queryOneUrl: 'pipe-network/gis/pipe-networks/work',
      deleteUrl: 'pipe-network/gis/pipe-networks',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-networks/export',
      exportFileName: '物探点数据.xlsx',
      downloadTemplateUrl: 'pipe-network/gis/pipe-networks/template/download',
      downloadTemplateName: '物探点数据导入模板.xlsx',
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      featurePointOptions: [], // 特征选项
      appendageOptions: [], // 附属物选项
      structureOptions: [], // 构筑物选项
      road: [], // 分区数据选项
      query: {
        road: '',
        classNo: '',
        geophysicalPointNumber: '',
        featurePoint: '',
        appendage: '',
        structure: '',
        textureMaterial: '',
        caliber: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
      columns,
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
    formatDate (time) {
      const date = new Date(time)
      return formatDate(date, 'YYYY-MM-DD HH:mm:ss')
    },
  },
  created () {
    this.listPipeLineMaterialOptions()
    this.listPipeDiameterSizeOptions()
    this.getFeaturePointOptions()
    this.getAllTenant()
    this.getZoneData()
    this.getPointList()
    this.getLineList()
    this.resetList()
    this.setSystemName()
  },
  methods: {
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}区域停水管控系统`)
    },
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    moment,
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-networks/empty/pipe/network').then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        },
      })
    },
    getLineList () {
      const params = {
        dictCode: 'PIPING_MATERIAL',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.LineList = data
      })
    },
    getPointList () {
      const params = {
        dictCode: 'FEATURE_POINTS',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.PointList = data
      })
    },
    modalFormOk () {
      this.queryList()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle () {
      this.$refs.importModal.show()
    },
    changeFile (info) { },
    customRequest (data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('zone_id', this.zoneId)
      this.saveFile(formData)
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis/pipe-networks/import',
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: '管点导入失败数据.xlsx' }))
        .then(({ hasErrorFile, message }) => {
          this.queryList()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    listPipeLineMaterialOptions () {
      listPipeNetworkByGroupProperties('texture_material').then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeDiameterSizeOptions () {
      listPipeNetworkByGroupProperties('caliber').then(({ data }) => {
        this.pipeDiameterSizeOptions = data
      })
    },
    getFeaturePointOptions () {
      listPipeNetworkByGroupProperties('feature_point').then(({ data }) => {
        this.featurePointOptions = data
      })

      listPipeNetworkByGroupProperties('appendage').then(({ data }) => {
        this.appendageOptions = data
      })

      listPipeNetworkByGroupProperties('structure').then(({ data }) => {
        this.structureOptions = data
      })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
